import React from 'react';
import { KompisCheckbox } from '@inter-ikea-kompis/react-components';
import { SpaceProps } from 'styled-system';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export enum CheckboxAlignButtonEnum {
  left = 'left',
  right = 'right'
}
export enum CheckboxLayoutEnum {
  subtle = 'subtle',
  emphasised = 'emphasised'
}

type CheckboxProps = {
  label: string;
  id?: string;
  checked: boolean;
  onChange: (event: CustomEvent) => void;
  disabled?: boolean;
  alignButton?: CheckboxAlignButtonEnum;
  //layout is either black or blue checkbox color
  layout?: CheckboxLayoutEnum;
  errorMessage?: string;
  hovered?: boolean;
  invalid?: boolean;
  required?: boolean;
} & SpaceProps;

const Checkbox = ({
  label,
  checked,
  onChange,
  disabled,
  alignButton,
  layout,
  errorMessage,
  invalid,
  required
}: CheckboxProps) => {
  return (
    <KompisCheckbox
      label={label}
      onChange={onChange}
      checked={checked}
      theme={SkapaTheme}
      aria-checked={checked}
      disabled={disabled}
      errorMessage={errorMessage}
      alignButton={alignButton}
      layout={layout}
      required={required}
      invalid={invalid}
    />
  );
};

export default Checkbox;
